import { useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useSwapAuthToken } from '~/hooks/useSwapAuthToken';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
const loaderName = 'switch-business';
export const prevBusinessIdKey = 'prevBusinessId';
export function useSwitchBusiness() {
    const history = useHistory();
    const { t: commonTexts } = useLocaleKeys('common');
    const { startLoader, stopLoader, showErrorToast } = useOverlayContext();
    const { getState } = useStoreStatic();
    const { api, logBI } = useStoreActions();
    const { localStorage } = useIoContext();
    const swapAuthToken = useSwapAuthToken();
    function getPrevBusinessId() {
        return localStorage.getItem(prevBusinessIdKey);
    }
    async function switchBusiness(businessId) {
        let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const showFailureToast = ()=>showErrorToast(commonTexts.toasts.failedToSwitchBusiness(), 'switch-business-failure');
        if (!businessId) {
            showFailureToast();
            history.push(routes.logout);
            return;
        }
        const prevBusinessId = selectors.user.businessId(getState());
        startLoader(loaderName);
        const authToken = await handlePromise(api.user.switchBusiness(businessId));
        logBI(10354);
        if (authToken.data) {
            prevBusinessId && localStorage.setItem(prevBusinessIdKey, prevBusinessId);
            Sentry.addBreadcrumb({
                type: 'switchBusiness',
                data: {
                    businessId,
                    prevBusinessId
                }
            });
            await swapAuthToken(authToken.data, {
                route: options.newRoute
            });
        } else {
            showFailureToast();
        }
        stopLoader(loaderName);
    }
    return {
        switchBusiness,
        getPrevBusinessId
    };
}
